import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.71604 2.95003C2.7993 2.7768 2.97449 2.66663 3.16669 2.66663H12.8334C13.0256 2.66663 13.2007 2.7768 13.284 2.95003C13.3673 3.12326 13.3439 3.32889 13.2238 3.47897L10.1827 7.28044C10.0644 7.42819 10 7.61179 10 7.80103V12.1666C10 12.811 9.4777 13.3333 8.83336 13.3333H7.16669C6.52235 13.3333 6.00003 12.811 6.00003 12.1666V7.80103C6.00003 7.61176 5.93562 7.42819 5.81743 7.28045L2.77626 3.47897C2.65619 3.32889 2.63278 3.12326 2.71604 2.95003ZM4.207 3.66663L6.59828 6.65573C6.59827 6.65573 6.59828 6.65574 6.59828 6.65573C6.85834 6.9808 7.00003 7.3847 7.00003 7.80103V12.1666C7.00003 12.2587 7.07463 12.3333 7.16669 12.3333H8.83336C8.92542 12.3333 9.00002 12.2587 9.00002 12.1666V7.80103C9.00002 7.38467 9.14175 6.98078 9.4018 6.65573L11.7931 3.66663H4.207Z"
      fill="currentColor"
    />
  </SvgIcon>
));
